import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getProviderList = createAsyncThunk("provdier/getProviders", async ({ page = 1, filters = {} }, thunkAPI) => {
  try {
    const queryParams = new URLSearchParams({
        page,
        limit: 10,
        ...filters,
      });
    const res = await axios.get(`${BACKEND_URL}/provider/list?${queryParams.toString()}`);
    console.log("data", res.data);
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers");
  }
});

const providerListingSlice = createSlice({
  name: "providerListing",
    initialState: {
      providers: [],
      pagination: {},
      loading: false,
      error: null,
    },
    extraReducers: (builder) => {
      builder
        .addCase(getProviderList.pending, (state) => {
            state.loading = true;
        })
        .addCase(getProviderList.fulfilled, (state, action) => {
            state.providers = action.payload.data;
            state.pagination = {
                current_page: action.payload.current_page,
                last_page: action.payload.last_page,
                total: action.payload.total,
            };
            state.loading = false;
        })
        .addCase(getProviderList.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch providers"; 
            state.loading = false;
        })
    },
});

export default providerListingSlice.reducer;